import { Injectable} from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class RegionalService {    

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Regional por id
     * @param id ID da Regional
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "regional/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Regional
     * @param id ID da Regional
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "regional"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Regional
     * @param id ID
     */
    getAllList(params: any): Observable<any> {
        
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix+"regional/lista"+env,{headers: this.authService.getAuthHeaders()});
    }

    /**
     * Delete de Regional
     * @param id ID da Regional
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "regional/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Regional
     * @param params Json Regional
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "regional", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }


    /**
     * Atualiza Regional
     * @param params Json Regional
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "regional/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }    

}
